import { useMemo } from 'react';

import { useAppSelector } from 'hooks/store';
import { useFieldValues } from 'pages/audience/shared/hooks/field-values';
import { useMultiRfm } from 'pages/audience/shared/hooks/multi-rfm';
import { isValidFieldValues } from 'pages/audience/utilities';
import { selectAudienceIsMultiRfm, selectAudienceSelectedSearch } from 'store/selectors';
import { SearchType } from 'types/api/audience';

export const useIsValidFieldValues = () => {
  const advanced = useAppSelector(selectAudienceIsMultiRfm);
  const selectedSearchType = useAppSelector(selectAudienceSelectedSearch);
  const { fieldValues } = useFieldValues();
  const { groups: multiRfmGroups } = useMultiRfm();

  return useMemo(() => {
    if (advanced) {
      for (const { fieldValues: rfmSetFieldValues } of multiRfmGroups) {
        const isValid = isValidFieldValues(SearchType.Basic, rfmSetFieldValues);

        if (isValid) {
          continue;
        }

        return false;
      }

      return true;
    }

    return isValidFieldValues(selectedSearchType, fieldValues);
  }, [advanced, fieldValues, multiRfmGroups, selectedSearchType]);
};
